import YouTube, { YouTubeProps } from 'react-youtube';

import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  useBreakpointValue,
  VisuallyHidden,
} from '@chakra-ui/react';

type VideoModalProps = {
  videoId: string | null;
  title?: string;
  /**
   * When set, forces closed captions on and requests them in this language. YouTube will
   * auto-translate from the video's source captions when a native track isn't available
   * (e.g. 'en' on an Arabic-language video).
   */
  captionsLang?: string;
  onClose: () => void;
};

export function VideoModal({ videoId, title = 'Video', captionsLang, onClose }: VideoModalProps) {
  const videoHeight = useBreakpointValue({ base: '240px', md: '649px' }, { fallback: 'md' });

  const videoOptions: YouTubeProps['opts'] = {
    height: videoHeight,
    host: 'https://www.youtube-nocookie.com',
    playerVars: {
      autoplay: 1,
      rel: 0,
      ...(captionsLang ? { cc_load_policy: 1, cc_lang_pref: captionsLang, hl: captionsLang } : {}),
    },
    width: '100%',
  };

  return (
    <Modal isOpen={!!videoId} size='6xl' isCentered onClose={onClose}>
      <ModalOverlay backdropFilter='blur(10px) brightness(0.25)' />
      <ModalContent bg='grey.900' color='white'>
        <VisuallyHidden as={ModalHeader}>{title}</VisuallyHidden>
        <ModalCloseButton color='white' right='12px' top='12px' />
        <ModalBody px={0} py={{ base: '44px', md: '52px' }}>
          {videoId && <YouTube opts={videoOptions} title={title} videoId={videoId} />}
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}
